import { NoEditPlugin } from '@src/slide/application/no-edit/plugins/no-edit-plugin';
import {
    CommonTips, CommonTipsActionType, CommonTipsType,
    PPTEditorStateEnumType, i18n,
} from '@src/slide/application/service/edit-extension/edit-extension-export';
import { ILoginPlugin, LOGIN_PLUGIN_NAME } from '@src/slide/application/no-edit/plugins/login/login-plugin.interface';
import { IBaseEditorExtensionService } from '@src/slide/application/service/edit-extension/core/editor/base/interface';
import { IAuth } from '@src/slide/application/no-edit/plugins/auth/base/auth.interface';
import { AuthEventsKeys } from '@src/slide/application/no-edit/plugins/auth/base/auth-events.interface';
import { IAuthPluginBase } from '@src/slide/application/no-edit/plugins/auth/base/base/auth-plugin-base.interface';
import Auth from '@src/slide/application/no-edit/plugins/auth/base/auth';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

export default class AuthPluginBase extends NoEditPlugin implements IAuthPluginBase {
    declare protected editExtensionService?: IBaseEditorExtensionService;
    protected auth: IAuth;

    public initPlugin(): void {
        // 首次初始化Auth
        this.auth = this.createAuth();
        // 权限变化，需要刷新
        this.auth.event.on(AuthEventsKeys.AUTH_PRIVILEGE_CHANGE, (data) => {
            this.showRefreshByPrivilegeChange(data.tipsMessage);
            if (!data?.canEdit) {  // 从有权限，变为无权限。（从无变有，暂无需处理，会提示用户刷新）
                this.editExtensionService?.setEditState(PPTEditorStateEnumType.SELECTABLE);
            }
        });
    }

    /**
     * 监听权限相关回调
     * @param eventName
     * @param callBack
     */
    public onAuthEvent(eventName: AuthEventsKeys, callBack: (data: unknown) => void): void {
        this.auth.event.on(eventName, callBack);
    }

    public getAuth(): IAuth {
        return this.auth;
    }

    protected getUserInfo() {
        const loginPlugin = this.noEditService?.getPluginSync<ILoginPlugin>(LOGIN_PLUGIN_NAME);
        return loginPlugin?.userInfo;
    }

    protected getPrivilegeChangeTip(): string {
        return i18n.t('你的权限已发生变化。');
    }

    // 创建对应的auth实例
    protected createAuth(): IAuth {
        return new Auth({
            noEditService: this.noEditService,
            editExtensionService: this.editExtensionService,
        });
    }

    private showRefreshByPrivilegeChange(tipsMessage?: string): void {
        // 云编文档（查看者）drive 那边已经有提示了，这边不再提示
        if (ENV.DRIVE_ENV.IS_PREVIEW_DRIVE_FILE) return;
        const commonTipsConfig = {
            message: tipsMessage || this.getPrivilegeChangeTip(),
            commonTipsType: CommonTipsType.INFO,
            actionType: CommonTipsActionType.REFRESH,
        };
        CommonTips.getInstance().show(commonTipsConfig);
    }
}
